import React from "react";
import { TypeAnimation } from "react-type-animation";

type TypeAnimationSpeed = React.ComponentProps<typeof TypeAnimation>["speed"];
type TypeAnimationSequence = React.ComponentProps<typeof TypeAnimation>["sequence"];

type Props = {
  sequence: TypeAnimationSequence;
  className?: string;

  /**
   * Accepts:
   * - "slow" | "medium" | "fast" (depends on your library version)
   * - GranularSpeed object (library-specific)
   * - OR a plain number (ms per keystroke) — we convert it to GranularSpeed safely
   */
  speed?: TypeAnimationSpeed | number;

  repeat?: React.ComponentProps<typeof TypeAnimation>["repeat"];
};

const toLibrarySpeed = (s: TypeAnimationSpeed | number | undefined): TypeAnimationSpeed => {
  if (typeof s === "number") {
    // Some versions of react-type-animation use a granular speed object instead of a raw number.
    // We convert number -> granular object and cast to the library's expected type.
    return ({ type: "keyStrokeDelayInMs", value: s } as unknown) as TypeAnimationSpeed;
  }
  return s;
};

const TypedText: React.FC<Props> = ({ sequence, className, speed = 55, repeat = 0 }) => {
  return (
    <TypeAnimation
      sequence={sequence}
      wrapper="span"
      speed={toLibrarySpeed(speed)}
      repeat={repeat}
      cursor
      className={className}
    />
  );
};

export default TypedText;
